import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import ButtonWithLoading from '../../ButtonWithLoading/ButtonWithLoadingContainer';
import NextTitle from '../NextTitle/NextTitleContainer';
import { StyledButton as Button } from '../../../CommonComponents/Button';

const SkipButton = styled(Button.Link)`
  color: #0078D4;
  margin: 20px auto;
  display: block;
`;

const NextView = ({
  workflowId,
  clientId,
  backendKey,
  onNext,
  onSkip,
  doNotSave,
  validator,
  validationId,
  onPostProcess,
  onPostSave,
  validatedOnClick,
  nextTitle,
  isInSummaryEdit,
  onBackToSummary,
  nextIterators,
  dirtyGraphNodes,
  hasSkip,
}) => (
  <div className="adv-workflow-navigation-next">
    {isInSummaryEdit ? (
      <ButtonWithLoading
        workflowId={workflowId}
        className="adv-workflow-navigation-next-save-button"
        type="button"
        onClick={onBackToSummary(
          validationId,
          validator,
          backendKey,
          clientId,
          workflowId,
          doNotSave,
          onPostProcess,
          onPostSave,
          validatedOnClick,
          nextIterators,
          dirtyGraphNodes,
        )}
      >
        <NextTitle
          workflowId={workflowId}
          nextTitle={nextTitle}
          nextIteratorsLength={nextIterators.length}
        />
      </ButtonWithLoading>
    ) : (
      <ButtonWithLoading
        workflowId={workflowId}
        className="adv-workflow-navigation-next-save-button"
        type="button"
        onClick={onNext(
          validationId,
          validator,
          backendKey,
          clientId,
          workflowId,
          doNotSave,
          onPostProcess,
          onPostSave,
          validatedOnClick,
          dirtyGraphNodes,
        )}
      >
        <NextTitle
          workflowId={workflowId}
          nextTitle={nextTitle}
          nextIteratorsLength={nextIterators.length}
        />
      </ButtonWithLoading>
    )}

    {hasSkip && <SkipButton onClick={() => onSkip(workflowId)}>Skip</SkipButton>}
  </div>
);

NextView.defaultProps = {
  validatedOnClick: () => {},
  nextTitle: null,
};

NextView.propTypes = {
  nextTitle: PropTypes.string,
  validator: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPostProcess: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  doNotSave: PropTypes.bool.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  backendKey: createCustomPropType(isNonEmptyString).isRequired,
  validationId: createCustomPropType(isNonEmptyString).isRequired,
  validatedOnClick: PropTypes.func,
  onBackToSummary: PropTypes.func.isRequired,
  isInSummaryEdit: PropTypes.bool.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  dirtyGraphNodes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  onSkip: PropTypes.func.isRequired,
  hasSkip: PropTypes.bool.isRequired,
};

export default NextView;
